import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

function einleitungstext() {

	gsap.registerPlugin(ScrollTrigger);

	document.querySelectorAll('.einleitungsTextImage').forEach(imageContainer => {
		gsap.from(imageContainer, {
			xPercent: 100,
			opacity: 0,
			duration: 1,
			ease: "power2.out",
			scrollTrigger: {
				trigger: imageContainer,
				start: "top 75%",
				end: "top -10%",
				scrub: true,
			}
		});
	});
}

export {einleitungstext};